// Inline duotone SVG for server-rendered HTML. DuoIcon in src/prompt-builder/components renders
// the same markup for the React island, so hydration matches. Colours and size come from the
// .pb-duo classes in src/prompt-builder/styles.css.

import { DUOTONE_ICONS, type DuotoneName } from "./duotone-icons";

export function duoClass(extra = ""): string {
  return extra ? `pb-duo ${extra}` : "pb-duo";
}

export function duotoneSvg(name: DuotoneName, className = ""): string {
  const icon = DUOTONE_ICONS[name];
  return `<svg class="${duoClass(className)}" viewBox="${icon.viewBox}" aria-hidden="true" focusable="false"><path class="pb-duo-2" d="${icon.secondary}"></path><path class="pb-duo-1" d="${icon.primary}"></path></svg>`;
}
